import React from "react";

const SelectField = ({ label, name, options = [], required = false }) => (
  <div className="flex flex-col">
    <label htmlFor={name} className="mb-1 font-medium text-gray-700">
      {label}
    </label>
    <select
      id={name}
      name={name}
      required={required}
      className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-200"
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default SelectField;
